module.exports = __webpack_public_path__ + "media/images/icons/filled_forms_statistics-d36dadb620bce733920cd0940a106485.svg";